import React from "react"
import {Form} from "antd"
import {Select, SelectOption} from "ui"
import {CategoryData} from "../../../../types/CategoryData"
import {useTranslations} from "../hooks/use-translations"

interface Props {
  categories: CategoryData[];
  disabled: boolean;
}

export default function CategorySelectField({ categories, disabled }: Props) {
  const t = useTranslations()

  return (
    <>
      <Form.Item name="category_ids" label={t("coupons.form.category")}>
        <Select name="category_ids" mode="multiple" disabled={disabled} allowClear>
          {categories?.map(category => (
            <SelectOption key={category.id} value={category.id}>{category.name}</SelectOption>
          ))}
        </Select>
      </Form.Item>
      <div className="description">
        {t("coupons.form.category.description")}
      </div>
    </>
  );
}